import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customCurrency',
  standalone: true
})
export class CustomCurrencyPipe implements PipeTransform {

  transform(value: number): string {
    const absValue = Math.abs(value);
    const formattedValue = absValue.toLocaleString('es-CL', { 
      style: 'currency', 
      currency: 'CLP', 
      minimumFractionDigits: 0, 
      maximumFractionDigits: 0 
    });
    return value < 0 ? `- ${formattedValue}` : formattedValue;
  }

}
